import { hslToRgb, hslStyle, rgbToHsl } from "./util";

export function colorPickUI(parent, initArray, callbackFunc) {

    //elements
    let preview = parent.getElementsByClassName('color-prev')[0];
    let containerHL = parent.getElementsByClassName('color-pick')[0];
    let inputS = parent.querySelectorAll("input[type='range']")[0];
    let inputA = parent.querySelectorAll("input[type='range']")[1];
    let pickerHL = containerHL.children[1];
    let pickRect = containerHL.getBoundingClientRect();

    let active = false;
    let hexLock = false;

    let valueH = initArray[0];
    let valueS = initArray[1];
    let valueL = initArray[2];
    let valueA = initArray[3];
    let value = hslStyle(valueH, valueS, valueL, valueA);

    //init
    let pickH;
    let pickL;

    //init only after transforms completed????
    update();

    function update() {
        value = hslStyle(valueH, valueS, valueL, valueA);

        pickH = Math.map(valueH, 0, 360, 0, containerHL.clientWidth, true);
        pickL = Math.map(valueL, 100, 0, 0, containerHL.clientHeight, true);
        let pickS = valueS;
        let pickA = Math.round(valueA * 100);

        pickerHL.style.left = pickH + 'px';
        pickerHL.style.top = pickL + 'px';
        inputS.value = pickS;
        inputA.value = pickA;

        pickerHL.style.backgroundColor = hslStyle(valueH, valueS, valueL);
        containerHL.children[0].style.background = 'linear-gradient(0deg, hsla(0, 0%, 0%, 1.0) 0%, hsla(0, 0%, 50%, ' + Math.map(valueS, 0, 100, 1, 0) + ') 50%, hsla(0, 0%, 100%, 1.0) 100%)';

        preview.children[0].style.backgroundColor = hslStyle(valueH, valueS, valueL, valueA);
        // preview.children[1].value = 'H:' + valueH + ' S:' + valueS + '% L:' + valueL + '% A:' + Math.round(valueA * 100) + '%';

        // hex headache
        let rgb = hslToRgb(valueH, valueS, valueL);
        // console.log(rgb);

        let hexString = '';
        let hexA = Math.round(valueA * 255).toString(16);

        rgb.forEach((c) => {
            let hex = c.toString(16);
            if (hex.length == 1) {
                let newHex = '0' + hex;
                hexString += newHex;
                return;
            } else {
                hexString += hex;
                return;
            }
        });

        if (hexA.length == 1) {
            hexA = '0' + hexA;
        }
        // console.log(hexA);

        // console.log(hexString + hexA);
        if (hexLock == false) {
            preview.children[1].value = '#' + hexString + hexA;
        }
        hexLock = false;

        callbackFunc('#' + hexString + hexA);
    }

    //active
    containerHL.addEventListener("mousedown", downEvent);
    window.addEventListener("mouseup", upEvent);
    containerHL.addEventListener("touchstart", downEvent);
    window.addEventListener("touchend", upEvent);

    //pick
    window.addEventListener("mousemove", dragEvent);
    window.addEventListener("touchmove", dragEvent);

    inputS.addEventListener("input", function (e) {
        valueS = inputS.value;
        update();
    });

    inputA.addEventListener("input", function (e) {
        valueA = inputA.value / 100;
        update();
    });

    preview.children[1].addEventListener('input', function (e) {
        const val = preview.children[1].value;
        //sweatyyyyyyy
        if (val.toUpperCase() == 'SWEATY') {
            let div = document.createElement('DIV');
            div.id = 'borderSweaty-icon';
            div.classList.add('use');
            util.getId('cardBorder').appendChild(div);
            util.updateUse(util.getId('cardBorder'));
        }

        if (val.length < 7) {
            return;
        }

        hexLock = true;

        const reg = new RegExp("^#(?:[0-9a-fA-F]{3,4}){1,2}$");
        if (reg.test(val)) {

            let arr = val.replace('#', '').match(/.{1,2}/g);
            let r = parseInt(arr[0], 16);
            let g = parseInt(arr[1], 16);
            let b = parseInt(arr[2], 16);
            let a = parseInt(arr[3], 16);
            if (isNaN(a)) {
                a = 255;
            }

            // console.log(r + ' ' + g + ' ' + b + ' ' + a);
            let hsl = rgbToHsl(r, g, b);
            valueH = hsl[0];
            valueS = hsl[1];
            valueL = hsl[2];
            valueA = a / 255;
            // console.log(val.length);
            update();
        }
    });

    function downEvent(e) {
        active = true;
    }

    function upEvent(e) {
        active = false;
    }

    function dragEvent(e) {
        // console.log(e);
        if (!active) {
            return;
        }

        if (e.touches != undefined) {
            e.clientX = e.touches[0].clientX;
            e.clientY = e.touches[0].clientY;
        }

        // console.log(pickRect);
        pickRect = containerHL.getBoundingClientRect();

        valueH = Math.round(Math.map(e.clientX - pickRect.x, 0, containerHL.clientWidth, 0, 360, true));
        valueL = Math.round(Math.map(e.clientY - pickRect.y, 0, containerHL.clientHeight, 100, 0, true));

        update();
    }
}